import GraphTooltip from 'components/GraphTooltip';
import { motion } from 'framer-motion';
import { orderBy } from 'lodash';
import React from 'react';
import { dateFormatterFullDate } from '../LineGraphDataValidation';
import { spring } from '../transition';
import { LineGraphSlice } from './useLines';

interface LineTooltipProps {
    currentSlice: LineGraphSlice;
    hoveredLineId?: string | undefined;
    graphRef: React.RefObject<HTMLDivElement>;
    innerHeight: number;
    marginTop: number;
}

export const LineTooltip: React.FC<LineTooltipProps> = ({
    currentSlice,
    hoveredLineId,
    graphRef,
    innerHeight,
    marginTop
}) => {
    return (
        <>
            <motion.line
                animate={{
                    x1: currentSlice.x,
                    x2: currentSlice.x
                }}
                transition={spring}
                y1={marginTop}
                y2={innerHeight + marginTop}
                strokeDasharray='6 6'
                stroke='#818c9c'
                pointerEvents='none'
            />
            <GraphTooltip
                points={orderBy(currentSlice.points, (p) => p.lineId.toString()).map((point) => ({
                    label: point.lineId.toString(),
                    subLabel: dateFormatterFullDate(point.timestamp),
                    value: point.valueFormatted,
                    yValue: point.value || 0,
                    color: point.color,
                    highlight: point.lineId === hoveredLineId
                }))}
                graphRef={graphRef}
                spacing={70}
            />
        </>
    );
};
